<template>
  <vx-card title="Donnée de l'exploration">
    <vs-table max-items="10" pagination stripe :data="explorationData">
      <template slot="thead">
        <vs-th>Url de la page</vs-th>
        <vs-th><span class="txt_align_right w-full">Réponse HTTP</span></vs-th>
        <vs-th
          ><span class="txt_align_right w-full"
            >Temps de chargement total (s)</span
          ></vs-th
        >
        <vs-th><span class="txt_align_right w-full">Balise(s) h1</span></vs-th>
        <vs-th
          ><span class="txt_align_right w-full">Nombre de mots</span></vs-th
        >
        <vs-th
          ><span class="txt_align_right w-full">Nombre d'image(s)</span></vs-th
        >
        <vs-th
          ><span class="txt_align_right w-full"
            >Balise(s) alt non renseignée</span
          ></vs-th
        >
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="index" v-for="(row, index) in data">
          <vs-td class="max-w-1/3">
            <span class="url_box">{{ decodeURI(row["address_full"]) }}</span>
          </vs-td>
          <vs-td class="fw-bold txt_align_right">{{
            row["response_code"]
          }}</vs-td>
          <vs-td class="txt_align_right"
            >{{ parseFloat(row["time_total_load"] / 1000).toFixed(2) }}s</vs-td
          >
          <vs-td class="txt_align_right">{{ row["h1_count"] }}</vs-td>
          <vs-td class="txt_align_right">{{
            row["content_count_words"]
          }}</vs-td>
          <vs-td class="txt_align_right">{{ row["images_count"] }}</vs-td>
          <vs-td class="txt_align_right">{{ row["images_invalid_alt"] }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import utilsMixin from "@/mixins/utilsMixin";

export default {
	name: "ExplorationTable",
	props: {
		explorationData: Array
	},
	mixins: [utilsMixin]
};
</script>

<style scoped>
.txt_align_right {
  text-align: right;
}
</style>
